export default {
  bind(el, binding) {
    el.addEventListener("input", function(e) {
      let value = e.target.value;
      let formattedValue = value.replace(/\D/g, "");
      let intValue = parseInt(formattedValue, 10);
      if (intValue > 2147483647) {
        intValue = 2147483647; // valor máximo de int32
        formattedValue = intValue.toString();
      }
      if (value !== formattedValue) {
        e.target.value = formattedValue;
        el.dispatchEvent(new Event("input"));
      }
    });
  }
};
